module.exports = __webpack_public_path__ + "static/media/help-img1.620cad52.png";